import { FinancialInformation } from '@/components/pages/my-profile/FinancialInformation';
import { FC } from 'react';

const MyProfileFinancialInformation: FC = () => {
  return <FinancialInformation />;
};

export default MyProfileFinancialInformation;
